module.exports = __webpack_public_path__ + "static/media/uk.ab6c966d.jpg";